import { Injectable } from '@angular/core';

import { IImageCropperDialogConfig } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class CropperModalDialogService {
    showCropperPopupDialog(config: IImageCropperDialogConfig): Promise<any> {
        const modalDialogEl = document.querySelector('[aza-rws-image-cropper-dialog]');
        this.showElement(modalDialogEl);
        const promise = new Promise<any>((resolve, reject) => {
            const cancelControl = modalDialogEl.querySelector('[aza-rws-cropper-control-cancel]') as HTMLElement;
            cancelControl.onclick = ev => resolve(null);
            const applyControl = modalDialogEl.querySelector('[aza-rws-cropper-control-apply]') as HTMLElement;
            applyControl.onclick = ev => resolve({});
            const selectFileInputEl = modalDialogEl.querySelector('[aza-rws-cropper-select-file-input-element]') as HTMLInputElement;
            selectFileInputEl.value = null;
            selectFileInputEl.onchange = async ev => {
                config.imageFileSelectedSubject.next({ event: ev, fieldId: config.fieldId });
            };
            const cropButtonEl = modalDialogEl.querySelector('[aza-rws-image-field-control-crop]') as HTMLElement;
            cropButtonEl.onclick = ev => config.cropButtonClickedSubject.next();
            const selectFileControlEl = modalDialogEl.querySelector('[aza-rws-image-field-control-select-file]') as HTMLElement;
            selectFileControlEl.onclick = ev => {
                selectFileInputEl.value = null;
                selectFileInputEl.click();
            };
            selectFileInputEl.click();
        });
        return promise;
    }

    hidePopupDialog(): void {
        // const modalDialogOverlayEl = document.querySelector('[aza-rws-modal-dialog-overlay]');
        const modalDialogEl = document.querySelector('[aza-rws-image-cropper-dialog]');
        // this.hideElement(modalDialogOverlayEl);
        this.hideElement(modalDialogEl);
        // const modalDialogTextEl = modalDialogEl.querySelector('[aza-rws-modal-dialog-text]') as HTMLElement;
        // modalDialogTextEl.innerText = '';
    }

    hideElement(el: Element): void {
        el.classList.add('display-none');
    }

    showElement(el: Element): void {
        el.classList.remove('display-none');
    }
}
